export function replaceInList<T>(items: T[], index: number, newItem: T): T[] {
  const itemsBefore = items.slice(0, index);
  const [_, ...itemsAfter] = items.slice(index);

  return [...itemsBefore, newItem, ...itemsAfter];
}
